import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackHeaderMarkAsStarredButtonClick, trackHeaderUnmarkAsStarredButtonClick } from './tracking';
import { unmarkChatAsStarred, markChatAsStarred } from '../../actions/chatOperations';
import { ChatHeaderMarkStarredButton } from '../../components/ChatHeader/ChatHeaderMarkStarredButton';
import { ChatHeaderUnMarkStarredButton } from '../../components/ChatHeader/ChatHeaderUnMarkStarredButton';
import { currentChatOpponentIdSelector, currentOpenChatSelector, hostTypeSelector } from '../../selectors';
import { EDeviceType } from '../../types/deviceType';
import { EHostType } from '../../types/hostType';

export const ChatHeaderMarkStarredButtonContainer = () => {
  const currentChat = useSelector(currentOpenChatSelector);
  const opponentId = useSelector(currentChatOpponentIdSelector);

  const device = useDeviceType();
  const isMobile = device !== EDeviceType.Desktop;
  const hostType = useSelector(hostTypeSelector);
  const isIframe = hostType === EHostType.Frame;

  const { availableActions, offer, chatId, isStarred } = currentChat || {};

  const dispatch = useDispatch();

  const isMarkAsStarredAvailable = availableActions?.includes('markAsStarred');
  const isUnmarkAsStarredAvailable = availableActions?.includes('unmarkAsStarred');

  const handleButtonClick = React.useCallback(() => {
    if (!chatId) {
      return;
    }
    if (isStarred) {
      dispatch(unmarkChatAsStarred({ chatId }));
      trackHeaderUnmarkAsStarredButtonClick(offer, opponentId);

      return;
    }

    dispatch(markChatAsStarred({ chatId }));
    trackHeaderMarkAsStarredButtonClick(offer, opponentId);
  }, [chatId, isStarred, dispatch, offer, opponentId]);

  if (isStarred && isUnmarkAsStarredAvailable) {
    return <ChatHeaderUnMarkStarredButton isMobile={isMobile || isIframe} onClick={handleButtonClick} />;
  }
  if (!isStarred && isMarkAsStarredAvailable) {
    return <ChatHeaderMarkStarredButton isMobile={isMobile || isIframe} onClick={handleButtonClick} />;
  }

  return null;
};
